import { NavLink } from 'react-router-dom';
import React from 'react';
import SideNavBar from './SideNavBar';

function Birthday() {
  return (
    <div className="flex w-full h-screen  dashboard-thin-scroll">
      {/* Sidebar */}
      <div className="w-60 p-4 font-bold bg-gradient-to-r from-green-800 to-yellow-200 overflow-y-auto custom-scrollbar">
        <SideNavBar />
      </div>
    </div>
  );
}

export default Birthday;
